"use strict";

import angular from "angular";

import template from "./dashboard.component.html";
import "./dashboard.component.scss";

import _ from "lodash";

import { VisualizationsCompaniesManagement } from "../../../presentation/services/CompaniesManagement/VisualizationsCompaniesManagement.data";

class DashboardComponent {
    constructor(ThemesService, $scope) {
        this.sections = [];

        this.ThemesService = ThemesService;
        this.$scope = $scope;
    }

    $onInit() {
        this._setSections();
    }

    $onChanges(changes) {
        if (!_.isEmpty(_.get(changes, "dashboard.previousValue") || {}))
            this._setSections();
    }

    _setSections() {
        this.loading = true;
        this.sections = this.dashboard.sections.map((section) => {
            const visualizations = section.visualizations.map(
                (sectionVisualization) => {
                    const viz = VisualizationsCompaniesManagement(
                        this.ThemesService.getTheme()
                    ).find(
                        (visualization) =>
                            visualization._id === sectionVisualization
                    );

                    return viz;
                }
            );

            section.visualizationsProperties = visualizations;

            return section;
        });
        const runningTimeOut = setTimeout(() => {
            this.loading = false;
            this.$scope.$applyAsync();
        }, 100);
        this.$scope.$on("$destroy", () => {
            clearTimeout(runningTimeOut);
        });
    }
}

export { DashboardComponent };

DashboardComponent.$inject = ["ThemesService", "$scope"];

const name = "dashboardComponent";
const def = {
    bindings: {
        dashboard: "<",
        currentDate: "<",
        currentFilters: "<",
        accountingId: "<",
        accountingData: "<",
        onOpenShowtime: "&"
    },
    controller: DashboardComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
